import { modelComposition } from 'trait/composition'

const descriptor = 'model::recent'

export default modelComposition(descriptor)
